import React from 'react';
import '../components/Loader.css';

export default function Spinner({ size = 14, style }) {
  return <span className="ij-loader" style={{ width: size, height: size, display: 'inline-block', verticalAlign: 'middle', ...style }} />;
}
